import React, { useState, useEffect } from 'react';
import Card from "../components/common/Card";
import Form from '../components/common/form';
import Tasks from './Tasks';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { success } from "../components/common/notification"

// Importing Packages
import { v4 as uuidv4 } from 'uuid';

// remove window.location.reload and display edit and delete inside modal
const Notes = () => {
    const [tasks, setTasks] = useState([]);

    // Fetching from Local Storage
    const getTasks = JSON.parse(localStorage.getItem("taskAdded"));

    useEffect(() => {
        if (getTasks == null) {
            setTasks([])
        } else {
            setTasks(getTasks);
        }
    }, [])

    const handleAdd = (task) => {
        const id = uuidv4();
        const newTask = { id, task: task.notes }
        setTasks([...tasks, newTask]);
        localStorage.setItem("taskAdded", JSON.stringify([...tasks, newTask]));
        success('Success! Added to task list')
    }
    const handleEdit = (id) => {
        const task = prompt("Task Name")
        console.log('Edit', id)
        let data = JSON.parse(localStorage.getItem('taskAdded'));
        const myData = data.map(x => {
            if (x.id === id) {
                return {
                    ...x,
                    task: task,
                    id: uuidv4()
                }
            }
            return x;
        })
        localStorage.setItem("taskAdded", JSON.stringify(myData));
        window.location.reload();
    }
    const handleDelete = (id) => {
        const deleteTask = tasks.filter((task) => task.id !== id);
        setTasks(deleteTask)
        localStorage.setItem("taskAdded", JSON.stringify(deleteTask));
        success('Success! Deleted a task ')

    }

    return (
        <>
            <Card children={
                <>
                    <Form handleSubmit={handleAdd}
                        inputStyles={'rounded-lg w-full text-kombuGreen placeholder:text-kombuGreen border-solid border-2 border-light-blue-500 p-2'}
                        inputData={{ text: "text", name: "notes", id: "notes", placeholder: "Add a Note", min: 3, max: 15 }}
                        icon={{ iconName: "FaPlus", iconStyles: "cursor-pointer text-successColor text-2xl hover:text-gray-500" }}

                    />
                    <ul className="container flex flex-col">
                        {tasks.length > 0 ?
                            tasks.map((task, idx) => <Tasks key={idx} task={task} edit={handleEdit} remove={handleDelete} />)
                            :
                            <p>No task created</p>}
                    </ul>
                </>

            } styles={"text-teal-600"} />
            <ToastContainer />
        </>)

        ;
}

export default Notes;